import React, { useState, useEffect } from 'react';
import { auth, db } from '../firebaseConfig';
import { doc, onSnapshot } from 'firebase/firestore';
import './Marketplace.css';

const TAPJOY_APP_ID = process.env.REACT_APP_TAPJOY_APP_ID;

export default function Marketplace() {
  const currentUser               = auth.currentUser;
  const [iframeReady, setIframeReady] = useState(false);
  const [stats, setStats]             = useState({ taskStreamsEarned: 0, tasksCompleted: 0 });

  useEffect(() => {
    if (!currentUser) return;
    return onSnapshot(doc(db, 'users', currentUser.uid), snap => {
      if (snap.exists()) {
        const d = snap.data();
        setStats({
          taskStreamsEarned: d.taskStreamsEarned || 0,
          tasksCompleted:    d.tasksCompleted    || 0,
        });
      }
    });
  }, [currentUser]);

  const offerwallUrl = currentUser && TAPJOY_APP_ID
    ? `https://offerwall.tapjoy.com/multirewards/?app_id=${TAPJOY_APP_ID}&uid=${currentUser.uid}&currency_name=Streams&currency_amount=1`
    : null;

  return (
    <div className="mkt-page">
      {/* grid overlay */}
      <div className="mkt-grid-overlay" aria-hidden="true" />

      {/* ── Header ── */}
      <header className="mkt-header">
        <h1 className="mkt-title">Tasks</h1>
        <p className="mkt-subtitle">Complete offers &amp; earn Stream tokens</p>
      </header>

      {/* ── Stats ── */}
      <div className="mkt-stats">
        <div className="mkt-stat">
          <span className="mkt-stat__value">
            {stats.taskStreamsEarned.toLocaleString()}
          </span>
          <span className="mkt-stat__label">Streams Earned</span>
        </div>
        <div className="mkt-stat__divider" />
        <div className="mkt-stat">
          <span className="mkt-stat__value">{stats.tasksCompleted}</span>
          <span className="mkt-stat__label">Tasks Done</span>
        </div>
      </div>

      {/* ── How it works ── */}
      <div className="mkt-steps">
        {[
          { n: '1', text: 'Pick a task' },
          { n: '2', text: 'Complete it' },
          { n: '3', text: 'Streams credited' },
        ].map(({ n, text }, i, arr) => (
          <React.Fragment key={n}>
            <div className="mkt-step">
              <span className="mkt-step__num">{n}</span>
              <span className="mkt-step__text">{text}</span>
            </div>
            {i < arr.length - 1 && <span className="mkt-step__arrow">›</span>}
          </React.Fragment>
        ))}
      </div>

      {/* ── Offerwall ── */}
      <div className="mkt-offerwall-card">
        {!iframeReady && (
          <div className="mkt-offerwall-loading">
            <span className="mkt-spinner" />
            <span>Loading offers...</span>
          </div>
        )}

        {offerwallUrl ? (
          <iframe
            className="mkt-offerwall-frame"
            src={offerwallUrl}
            title="StreamStack Task Marketplace"
            allow="clipboard-write"
            onLoad={() => setIframeReady(true)}
            style={{ opacity: iframeReady ? 1 : 0 }}
          />
        ) : (
          <p className="mkt-offerwall-empty">Sign in to view available tasks.</p>
        )}
      </div>
    </div>
  );
}
